import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import {
  MemberPaymentTransaction,
  PaymentAPI,
  ResponseStatus
} from '@/api/payment'
import store from '@/store'

export interface PaymentCreateOrder {
  (paymentMethod: string): Promise<{
    orderId: string
    walletTransactionId: string
  }>
}

export interface PaymentCallback {
  (orderId: string): Promise<void>
}

export interface PaymentErrorCallback {
  (err: Error): void
}

export interface PaymentCompleteCallback {
  (walletTransactionId: string): void
}

export interface PaymentCancelCallback {
  (walletTransactionId: string): void
}

export interface PaymentCallbacks {
  createOrder: PaymentCreateOrder
  onApprove?: PaymentCallback
  onComplete?: PaymentCompleteCallback
  onError?: PaymentErrorCallback
  onCancel?: PaymentCancelCallback
}

@Module({ dynamic: true, store: store, namespaced: true, name: 'payment' })
export default class MemberModule extends VuexModule {
  paymentCallbacks: PaymentCallbacks | null = null
  isTournamentEntryFeePaymentDialogVisible: boolean = false
  tournamentEntryFee: string = ''

  // Member transaction
  transactions: MemberPaymentTransaction[] = []
  transactionsCurrentPage: number = 1
  transactionsPageCount: number = 1
  transactionsTotal: number = 0

  @Mutation
  SET_TOURNAMENT_ENTRY_FEE_PAYMENT_DIALOG_VISIBLE(params: {
    visible: boolean
    fee: string
    callbacks: PaymentCallbacks
  }) {
    this.isTournamentEntryFeePaymentDialogVisible = params.visible
    this.tournamentEntryFee = params.fee
    this.paymentCallbacks = params.callbacks
  }

  @Action
  showTournamentEntryFeePaymentDialog(params: {
    fee: string
    callbacks: PaymentCallbacks
  }) {
    this.context.commit('SET_TOURNAMENT_ENTRY_FEE_PAYMENT_DIALOG_VISIBLE', {
      visible: true,
      fee: params.fee,
      callbacks: params.callbacks
    })
  }

  @Action
  closeTournamentEntryFeePaymentDialog() {
    this.context.commit('SET_TOURNAMENT_ENTRY_FEE_PAYMENT_DIALOG_VISIBLE', {
      visible: false,
      fee: '',
      callbacks: null
    })
  }

  @Action
  setWalletDepositTransactionId(walletDepositTransactionId: string) {
    this.context.commit(
      'SET_CURRENT_WALLET_DEPOSIT_TRANSACTION_ID',
      walletDepositTransactionId
    )
  }

  @Action
  async getPaymentTransaction(page: number) {
    try {
      const response = await PaymentAPI.getMemberPaymentTransaction(page)
      const payload = response.data.payload
      if (response.data.status === ResponseStatus.Ok && payload) {
        this.context.commit('SET_PAYMENT_TRANSACTIONS', payload.items)
        this.context.commit('SET_PAYMENT_TRANSACTIONS_CURRENTPAGE', page)
        this.context.commit(
          'SET_PAYMENT_TRANSACTIONS_PAGECOUNT',
          payload.pageCount
        )
        this.context.commit('SET_PAYMENT_TRANSACTIONS_TOTAL', payload.itemCount)
      }
    } catch {}
  }

  @Mutation
  SET_PAYMENT_TRANSACTIONS(items: MemberPaymentTransaction[]) {
    this.transactions = items
  }

  @Mutation
  SET_PAYMENT_TRANSACTIONS_PAGECOUNT(count: number) {
    this.transactionsPageCount = count
  }

  @Mutation
  SET_PAYMENT_TRANSACTIONS_CURRENTPAGE(count: number) {
    this.transactionsCurrentPage = count
  }

  @Mutation
  SET_PAYMENT_TRANSACTIONS_TOTAL(count: number) {
    this.transactionsTotal = count
  }
}
